var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{staticClass:"container"},[_c('el-header',{attrs:{"height":"70px;display:flex;align-items:center"}},[_c('Headbar')],1),_vm._v(" "),_c('el-container',[_c('el-main',{staticClass:"main"},[_c('div',{staticClass:"view"},[(_vm.condition)?_c('router-view',{ref:"view"}):_vm._e()],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6bc1858e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/frame/Home.vue
// module id = CUIY
// module chunks = 155